module.exports = __webpack_public_path__ + "static/media/ic_close_waiting_room.623e7a40.svg";